<div class="h-100">
    @if (type === 'widget') {
		<div class="flex-align-center flex-space-between pad-bottom-M pad-M"
			 [class.c-p]="!_loading && !_initializing && applications.length > 0"
			 (click)="openDrawer()">
			<span class="font-MM fw-700">{{ 'page.financeDashboard.deadlines'|translate }}</span>
			<img *ngIf="!_loading && !_initializing && applications.length > 0" src="assets/icons/arrow-right.svg"
				 height="12" alt="">
		</div>
    }
	<app-table-component
		[loading]="_initializing || _loading"
		[columnDefinitions]="columnDefinitions"
		[data]="filteredApplications"
		[height]="'calc(100% - 45.59px)'"
		[type]="type"
		(sorted)="onSorted($event)"
		(rowClick)="onRowClick($event)">
		<!-- Custom templates -->
		<ng-template #applicationTemplate let-row>
			<app-display-application [application]="row.application"></app-display-application>
		</ng-template>
		<ng-template #contractTitleTemplate let-row>
			<div class="w-100 flex-center">
				<span class="font-M fw-500 text-overflow-ellipsis">{{('page.appDetails.finance.contracts.' + row.type)|translate}}</span>
			</div>
		</ng-template>
		<ng-template #expiryDateTemplate let-row>
			<div class="flex-align-center flex-justify-end">
				<app-chips size="m" [color]="getColor(row.expiryDate)">{{getTimeDiff(row.expiryDate)}}</app-chips>
			</div>
		</ng-template>
	</app-table-component>
</div>
